import { HttpBackend, HttpClientModule, provideHttpClient, withFetch, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule,APP_INITIALIZER } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { AppRoutingModule, CmsPageGuard, LogoutModule, PageLayoutComponent } from "@spartacus/storefront";
import { AppComponent } from './app.component';
import { SmartEditConfig } from '@spartacus/smartedit/root';
import { CustomHeaderModule } from "./custom-header/custom-header.module";
import { LayoutModule } from "@spartacus/storefront";
import { CustomFooterModule } from "./custom-footer/custom-footer.module";
import { CmsCommonModule } from "./cms-common/cms-common.module";
import { BannerModule } from "./banner/banner.module";
import { CustomCreateAccountModule } from "./custom-create-account/custom-create-account.module";
import { CustomGigyaRaasModule } from "./custom-gigya-raas/custom-gigya-raas.module";
import { I18nModule, PageMetaService, provideConfig, RoutingConfig } from "@spartacus/core";
import { DashboardModule } from "./dashboard/dashboard.module"
import { SeqirusAuthGuard,  } from "./guards/seqirus-auth.guard";
import { RouterModule, Routes } from "@angular/router";
import { CustomAccountModule } from "./custom-account/custom-account.module";
import { JoinAccountModule } from "./join-account/join-account.module";
import { SeqirusNotAuthGuard } from "./guards/seqirus-not-auth.guard";
import { MyOrdersModule} from "./my-orders/my-orders.module"
import { CustomMyProfileModule } from "./custom-my-profile/custom-my-profile.module";
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { RegistrationModule } from "./registration/registration.module";
import { SummaryModule } from "./summary/summary.module"
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { OrgLocationModule } from "./org-location/org-location.module";
import { CustomStartOrderModule } from "./custom-start-order/custom-start-order.module";
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { FinancialDashboardModule } from "./financial-dashboard/financial-dashboard.module";
import { ContactUsModule } from "./contact-us/contact-us.module";
import { RecaptchaModule } from "ng-recaptcha";
import { RecaptchaFormsModule } from "ng-recaptcha";
import { AllInvoicesModule } from "./all-invoices/all-invoices.module";
import {PaymentStatusModule} from "./payment-status/payment-status.module"
import { PaymentInfoModule } from "./payment-info/payment-info.module";
import {OverviewModule} from "./overview/overview.module"
import { CustomOperationalEfficiencyModule } from "./custom-operational-efficiency/custom-operational-efficiency.module";
import { ClinicalSupportModule } from "./clinical-support/clinical-support.module";
import { SpartacusModule } from "./spartacus/spartacus.module";
import { Influenza65PlusComponent } from "./influenza-65-plus/influenza-65-plus.component";
import { Influenza65PlusModule } from "./influenza-65-plus/influenza-65-plus.module";
import { StartOrderUKModule } from "./start-order-uk/start-order-uk.module";
import { CustompagemetatitleService } from "./spartacus/services/custompagemetatitle.service";
import { CustomAllproductsModule } from "./custom-allproducts/custom-allproducts.module";
import { AboutModule } from "./about/about.module";
import { Flu360AsmComponent } from "./flu360-asm/flu360-asm.component";
import { Flu360AsmModule } from "./flu360-asm/flu360-asm.module";
import { HelpAndFaqModule } from "./help-and-faq/help-and-faq.module";
import { ClinicaldataFluadModule } from "./clinicaldata-fluad/clinicaldata-fluad.module";
import { FlucelvaxModule } from "./flucelvax/flucelvax.module";
import { AdjuvantAdvantageModule } from "./adjuvant-advantage/adjuvant-advantage.module";
import { UkTermsAndConditionsModule } from "./uk-terms-and-conditions/uk-terms-and-conditions.module";
import { FluadModule } from "./fluad/fluad.module";
import { OrderSummaryUkModule } from "./order-summary-uk/order-summary-uk.module";
import { ProfileactivationModule } from "./profileactivation/profileactivation.module";
import { CustomUkPublicModule } from "./custom-uk-public/custom-uk-public.module";
import { GoogleTagManagerConfiguration, GoogleTagManagerModule } from 'angular-google-tag-manager';
import { ReturnsUkModule } from "./returns-uk/returns-uk.module";
import { ClinicaldataFlucelvaxModule } from "./clinicaldata-flucelvax/clinicaldata-flucelvax.module";
import { AboutUkModule } from "./about-uk/about-uk-module";
import { AlfuriaModule } from "./afluria/alfuria.module";
import { MaterialsukModule } from "./materialsuk/materialsuk.module"
import { MyprofileUKModule } from "./myprofile-uk/myprofile-uk.module";
import { ProductsUkModule } from "./products-uk/products-uk-module";
import { UkContactUsModule } from "./uk-contact-us/uk-contact-us.module";
import { ProductAqivModule } from "./product-aqiv/product-aqiv.module";
import { UkCookiePolicyModule } from "./uk-cookie-policy/uk-cookie-policy.module";
import { USCookiePolicyModule } from "./us-cookie-policy/us-cookie-policy.module";
import { PrescribingInformationUkModule } from "./prescribing-information-uk/prescribing-information-uk.module";
import { CookieService } from 'ngx-cookie-service';
import { RegistrationUkModule } from "./registration_uk/registration-uk.module";
import { RweFlucelvaxModule } from "./rwe-flucelvax/rwe-flucelvax.module";
import { InfluenzaModule } from "./influenza/influenza.module";
import { SessiontimeoutModule } from "./sessiontimeout/sessiontimeout.module";
import { ErrorpageModule } from "./errorpage/errorpage.module";
import { UKQivcModule } from "./uk-qivc/uk-qivc.module";
import { CodingandbillingModule } from "./codingandbilling/codingandbilling.module";
import { ToolsAndResourcesModule } from "./tools-and-resources/tools-and-resources/tools-and-resources.module";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './error.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { GetgtmidService} from './spartacus/services/getgtmid.service'
import { FinancialDashboardUkModule } from "./financial-dashboard-uk/financial-dashboard-uk.module";
import { FlucelvaxCellbasedSolutionModule } from "./flucelvax-cellbased-solution/flucelvax-cellbased-solution.module";
import { FluadProductModule } from "./fluad-product/fluad-product.module";
import { CustomPipModule } from "./custom-pip/custom-pip.module";
import { SitemapModule } from "./sitemap/sitemap.module";
import { ScheduledPaymentModule } from "./scheduled-payment/scheduled-payment.module";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { CUSTOM_DATE_FORMATS } from "./all-invoices/all-invoices-left-section/all-invoices-left-section.component";
import { CustomDateAdapter } from "./shared/custom-date-adapter";
import { AsmresetpasswordModule } from "./asmresetpassword/asmresetpassword.module";
import { ReturnsUsModule } from "./returns-us/returns-us.module";
import { ReturnsThankyouPageModule } from "./returns-thankyou-page/returns-thankyou-page.module";
import { DynamiccontentModule } from "./dynamiccontent/dynamiccontent.module";

export const options: Partial<null|IConfig> | (() => Partial<IConfig>) = null;
export function initializeGtm(gtmConfigService: GetgtmidService) {

  return gtmConfigService.getGtmId();
  
 }

const routes:Routes=[
  { path: 'liveassist', redirectTo: '/?asm=true', pathMatch: 'full' },
  {
    path:'login',
    data: { pageLabel: '/login' },
    component: PageLayoutComponent,
    canActivate: [SeqirusNotAuthGuard]
  },
  {
      path: 'my-account',
      data: { pageLabel: '/my-account' },
      component: PageLayoutComponent,
      canActivate: [CmsPageGuard,SeqirusAuthGuard]
  },
  {
    path: 'organisation-location',
    data: { pageLabel: '/organisation-location' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusAuthGuard]
  },
  {
    path: 'organization-location',
    data: { pageLabel: '/organization-location' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusAuthGuard]
  },
   {
    path: '',
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusNotAuthGuard]
  }, 
  {
    path: 'homepage',
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusNotAuthGuard]
  },
  {
    path: 'about',
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusNotAuthGuard]
  },
  
  {
    path: 'my-profile',
    data: { pageLabel: '/my-profile' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusAuthGuard]
  },
  {
    path: 'changepassword',
    data: { pageLabel: '/changepassword' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusAuthGuard]
  },
  {
    path: 'register/join-account',
    data: { pageLabel: 'register/join-account' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusAuthGuard]
  },
  {
    path: 'joinAccountThankYou',
    data: { pageLabel: '/joinAccountThankYou' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusAuthGuard]
},
  {
  path: 'profileactivation',
  component: PageLayoutComponent,
  canActivate: [CmsPageGuard,SeqirusNotAuthGuard]
  },
  {
    path: 'orders',
    data: { pageLabel: '/orders' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusAuthGuard]
  },
  {
    path: 'orders/my-orders',
    data: { pageLabel: 'orders/my-orders' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusAuthGuard]
  },
  {
    path: 'start-order',
    data: { pageLabel: '/start-order' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusAuthGuard]
  },
  {
    path: 'register-for-materials',
    data: { pageLabel: '/register-for-materials' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusAuthGuard]
  },
  {
    path: 'returns',
    data: { pageLabel: '/returns' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusNotAuthGuard]
  },
  {
    path: 'financial-dashboard',
    data: { pageLabel: 'financial-dashboard' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusAuthGuard]
  },
  {
    path: 'financial-dashboard/all-invoices',
    data: { pageLabel: 'financial-dashboard/all-invoices' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusAuthGuard]
  },
  {
    path: 'payment-information',
    data: { pageLabel: '/payment-information' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusAuthGuard]
  },
  {
    path: 'payment-status',
    data: { pageLabel: '/payment-status' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusAuthGuard]
  },
  {
    path: 'help-and-faq',
    data: { pageLabel: '/help-and-faq' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusNotAuthGuard]
  },
  {
    path: 'contact-us',
    data: { pageLabel: '/contact-us' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusNotAuthGuard]
  },
  {
    path: 'overview',
    data: { pageLabel: '/overview' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusNotAuthGuard]
  },
  {
    path: 'products',
    data: { pageLabel: '/products' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusNotAuthGuard]
  },
  {
    path: 'products/aqiv',
    data: { pageLabel: '/products/aqiv' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusAuthGuard]
  },
  {
    path: 'products/qivc',
    data: { pageLabel: '/products/qivc' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusAuthGuard]
  },
  {
    path: 'createprofile',
    data: { pageLabel: '/createprofile' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusNotAuthGuard]
  },
  {
    path: 'forgotpassword',
    data: { pageLabel: '/forgotpassword' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard,SeqirusNotAuthGuard]
  },
  {
    path: 'liveassist',
    component: Flu360AsmComponent,
    canActivate: [CmsPageGuard,SeqirusNotAuthGuard]
  },
  {
    path: '?asm=true',
    component: Flu360AsmComponent,
    canActivate: [CmsPageGuard,SeqirusNotAuthGuard]
  },
]
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    CmsCommonModule,
    BrowserModule,
    StoreModule.forRoot({}),
    AppRoutingModule,
    EffectsModule.forRoot([]),
    SpartacusModule,
    CustomHeaderModule,
    LayoutModule,
    CustomFooterModule,
    BannerModule,
    CustomCreateAccountModule,
    CustomGigyaRaasModule,
    DashboardModule,
    I18nModule,
    MyOrdersModule,
    I18nModule,
    RouterModule.forChild(routes),
    CustomAccountModule,
    JoinAccountModule,
    CustomMyProfileModule,
    RegistrationModule,
    SummaryModule,
    FinancialDashboardModule,
    MatTableModule,
    MatPaginatorModule,
	  MatSortModule,
    MatInputModule,
    MatFormFieldModule,
    MatPaginatorModule,
    BrowserAnimationsModule,
    OrgLocationModule,
    CustomStartOrderModule,
	  NgxMaskModule.forRoot(),
    RecaptchaModule,
    RecaptchaFormsModule,
    ContactUsModule,
    AllInvoicesModule,
    HttpClientModule,
    PaymentStatusModule,
    PaymentInfoModule,
    OverviewModule,
    CustomOperationalEfficiencyModule,
    ClinicalSupportModule,
    Influenza65PlusModule,
    StartOrderUKModule,
    CustomAllproductsModule,
    AboutModule,
    Flu360AsmModule,
    HelpAndFaqModule  ,
    ClinicaldataFluadModule,
    FlucelvaxModule,
    AdjuvantAdvantageModule,
   UkTermsAndConditionsModule,
   FluadModule,
   OrderSummaryUkModule,
    ProfileactivationModule,
    CustomUkPublicModule,
   ClinicaldataFlucelvaxModule,
   ReturnsUkModule,
   AboutUkModule,
   ProductsUkModule,
   AlfuriaModule,
   MyprofileUKModule,
   ErrorpageModule,
   UkContactUsModule,
   ProductAqivModule,
   UkCookiePolicyModule,
   USCookiePolicyModule,
   PrescribingInformationUkModule,
   RweFlucelvaxModule,
   InfluenzaModule ,
   SessiontimeoutModule,
   UKQivcModule,
   CodingandbillingModule,
   ToolsAndResourcesModule,
   FinancialDashboardUkModule,
   FluadProductModule,
   FlucelvaxCellbasedSolutionModule,
   CustomPipModule,
   MaterialsukModule,
   SitemapModule,
   AsmresetpasswordModule,
   ReturnsThankyouPageModule,
   ScheduledPaymentModule,
   ReturnsUsModule,
   DynamiccontentModule,
   GoogleTagManagerModule.forRoot({
    id: initializeGtm(new GetgtmidService(document))
   
  }),
   RegistrationUkModule,
   ToastrModule.forRoot({
    timeOut: 3000,
    positionClass: 'toast-top-right',
    preventDuplicates: true,
  }),
  ],
  providers: [
   
   //{provide: 'googleTagManagerId', useValue: 'GTM-WWZ4T9K'},
    provideHttpClient(withFetch(), withInterceptorsFromDi()), provideAnimationsAsync(),{
    provide:PageMetaService,useClass:CustompagemetatitleService
  },{provide:DateAdapter,useClass:CustomDateAdapter},{provide:MAT_DATE_FORMATS,useValue:CUSTOM_DATE_FORMATS},
  /* {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true
  }, */
  CookieService,
  provideConfig({
    smartEdit: {
      storefrontPreviewRoute: 'cx-preview',
      allowOrigin: 'backoffice.caah8q6d5y-seqirusuk1-d3-public.model-t.cc.commerce.ondemand.com:443',
    },
  } as SmartEditConfig),
  provideConfig({
    routing:{
      routes:{
        product:{
          paths:['flu-vaccine-resources/:productCode'],
        }
      }
    }
  }),
  provideConfig({
    asm: {
      agentSessionTimer: {
        startingDelayInSeconds: 1800,
      },
    },
  })
  ],
  
  bootstrap: [AppComponent]
})
export class AppModule {
  
 }
